import React from 'react';
import { Box, Typography, Button, useMediaQuery } from '@mui/material';

import vision from '../assets/vision.png';
import xIcon from '../assets/x.png';
import discordIcon from '../assets/discord.png';
import authencityIcon from '../assets/authencity.png';
import user_first from '../assets/user_first.png';
import user_second from '../assets/user_second.png';

const StayTuned = () => {
  const isMobile = useMediaQuery('(max-width:439px)');
  const isTablet = useMediaQuery('(min-width:440px) and (max-width:1024px)');

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        px: isMobile ? 2 : isTablet ? 4 : 2,
      }}
    >
      <Box
        sx={{
          backgroundColor: '#FFFFFF',
          borderRadius: isMobile ? '18px' : '47px',
          maxWidth: '1400px',
          width: '100%',
          px: isMobile ? 2 : 8,
          pt: isMobile ? 5 : 10,
          pb: isMobile ? 2 : isTablet ? 8 : 15,
          textAlign: 'center',
        }}
      >
        <Box
          component="img"
          src={vision}
          alt="Vision"
          sx={{
            width: isMobile ? 80 : isTablet ? 97 : 160,
            height: isMobile ? 80 : isTablet ? 97 : 160,
            mb: isMobile ? 0.5 : 0,
          }}
        />

        <Typography
          sx={{
            color: '#000000',
            fontFamily: 'Unbounded, sans-serif',
            fontWeight: 500,
            fontStyle: 'normal',
            fontSize: isMobile ? '33.6px' : isTablet ? '30.43px' : '50px',
            lineHeight: isMobile ? '130%' : '100%',
            letterSpacing: 0,
            textAlign: 'center',
            px: isMobile ? 2 : 0,
            mb: isMobile ? 3 : 5,
          }}
        >
          Stay tuned for more.
        </Typography>

        <Typography
          sx={{
            color: '#000000',
            fontFamily: 'Sora, sans-serif',
            fontWeight: 400,
            fontStyle: 'normal',
            fontSize: '16px',
            lineHeight: '26px',
            letterSpacing: 0,
            textAlign: 'center',
            px: isMobile ? 2 : 0,
            mb: isMobile ? 7 : 10,
          }}
        >
          In the meantime, make sure to stay updated on our social profiles. You can find the links here:
        </Typography>

        <Box
          sx={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : isTablet ? 'column' : 'row',
            justifyContent: 'center',
            gap: 2,
            flexWrap: 'wrap',
          }}
        >
          <Box
            sx={{
              backgroundColor: '#000000',
              borderRadius: isMobile ? '12px' : '20px',
              px: isTablet ? 2 : 2,
              py: isMobile ? 2 : 1,
              width: isMobile ? '100%' : isTablet ? '100%' : '30%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
            }}
          >
            <Box
              component="img"
              src={xIcon}
              alt="X Logo"
              sx={{
                width: 45,
                height: 45,
                borderRadius: '50%',
                mb: 1,
              }}
            />

            {[{ img: user_first, handle: '@ASychov' }, { img: user_second, handle: '@spatiallyme' }].map(
              (user, index) => (
                <Box
                  key={index}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '100%',
                    mb: 2,
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, ml: 0.7 }}>
                    <Box
                      component="img"
                      src={user.img}
                      alt={user.handle}
                      sx={{
                        width: isMobile ? 48 : 60,
                        height: isMobile ? 48 : 60,
                        borderRadius: '50%',
                      }}
                    />
                    <Typography
                      sx={{
                        color: '#FFFFFF',
                        fontFamily: 'Sora, sans-serif',
                        fontWeight: 500,
                        fontStyle: 'normal',
                        fontSize: isMobile ? '16px' : isTablet ? '16px' : '20px',
                        lineHeight: isMobile ? '27.11px' : '41.95px',
                        letterSpacing: 0,
                      }}
                    >
                      {user.handle}
                    </Typography>
                  </Box>

                  <Button
                    component="a"
                    href={`https://twitter.com/${user.handle.replace('@', '')}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="contained"
                    sx={{
                      height: isMobile ? '40px' : '45px',
                      backgroundColor: '#FFFFFF',
                      color: '#000000',
                      boxShadow: 'none',
                      fontFamily: 'Sora, sans-serif',
                      fontWeight: isMobile ? 600 : 500,
                      fontStyle: 'normal',
                      fontSize: isMobile ? '12px' : isTablet ? '12px' : '16px',
                      lineHeight: '100%',
                      letterSpacing: 0,
                      verticalAlign: 'middle',
                      borderRadius: isMobile ? '32.31px' : '50px',
                      textTransform: 'none',
                      p: '10px 22px',
                      mr: 1,

                      '&:hover': {
                        transition: 'transform 0.3s ease',
                        boxShadow: 'none',
                        transform: 'scale(1.05)',
                      },
                    }}
                  >
                    Follow
                  </Button>
                </Box>
              )
            )}
          </Box>

          <Box
            sx={{
              backgroundColor: '#5865F2',
              borderRadius: isMobile ? '12px' : '20px',
              px: isTablet ? 2 : 2,
              py: isMobile ? 2 : 1,
              width: isMobile ? '100%' : isTablet ? '100%' : '30%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
            }}
          >
            <Box
              component="img"
              src={discordIcon}
              alt="Discord"
              sx={{
                alignSelf: 'flex-start',
                width: 45,
                height: 45,
                borderRadius: '50%',
              }}
            />

            <Typography
              sx={{
                fontFamily: 'Unbounded, sans-serif',
                fontWeight: 500,
                fontStyle: 'normal',
                fontSize: isMobile ? '18px' : isTablet ? '18px' : '24px',
                lineHeight: isMobile ? '27.11px' : '36.95px',
                letterSpacing: 0,
                textAlign: 'center',
                mt: 1.5,
                mb: isTablet ? 2.5 : 5.5,
              }}
            >
              Join our Discord.
            </Typography>

            <Button
              component="a"
              href="https://discord.gg/sfmwRVzKtb"
              target="_blank"
              rel="noopener noreferrer"
              variant="contained"
              sx={{
                height: isMobile ? '40px' : '45px',
                backgroundColor: '#FFFFFF',
                color: '#000000',
                boxShadow: 'none',
                fontFamily: 'Sora, sans-serif',
                fontWeight: isMobile ? 600 : 500,
                fontStyle: 'normal',
                fontSize: isMobile ? '10.99px' : isTablet ? '10.99px' : '16px',
                lineHeight: '100%',
                letterSpacing: 0,
                verticalAlign: 'middle',
                borderRadius: isMobile ? '32.31px' : '50px',
                textTransform: 'none',
                p: '10px 22px',
                mb: isTablet ? 3 : 0,

                '&:hover': {
                  transition: 'transform 0.3s ease',
                  boxShadow: 'none',
                  transform: 'scale(1.05)',
                },
              }}
            >
              Join Discord
            </Button>
          </Box>

          <Box
            sx={{
              background: '#e6f1f9',
              borderRadius: isMobile ? '12px' : '20px',
              px: isTablet ? 2 : 2,
              py: isMobile ? 2 : 1,
              width: isMobile ? '100%' : isTablet ? '100%' : '30%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
            }}
          >
            <Box
              component="img"
              src={authencityIcon}
              alt="Authencity"
              sx={{
                alignSelf: 'flex-start',
                width: 60,
                height: 55,
                borderRadius: '50%',
              }}
            />

            <Typography
              sx={{
                fontFamily: 'Unbounded, sans-serif',
                fontWeight: 500,
                fontStyle: 'normal',
                fontSize: isMobile ? '18.09px' : isTablet ? '18.09px' : '24px',
                lineHeight: isMobile ? '27.11px' : isTablet ? '27.11px' : '36.95px',
                letterSpacing: 0,
                textAlign: 'center',
                background: 'linear-gradient(73.57deg, #3843B9 24.72%, #4C95C8 72.8%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                mt: 0.4,
                mb: isTablet ? 2.5 : 5.5,
              }}
            >
              Explore Authencity
            </Typography>

            <Button
                component="a"
                href="https://authencity.io/"
                target="_blank"
                rel="noopener noreferrer"
                variant="contained"
                sx={{
                  height: isMobile ? '40px' : '45px',
                  backgroundColor: '#000000',
                  color: '#FFFFFF',
                  boxShadow: 'none',
                  fontFamily: 'Sora, sans-serif',
                  fontWeight: isMobile ? 600 : 500,
                  fontStyle: 'normal',
                  fontSize: isMobile ? '10.99px' : isTablet ? '10.99px' : '16px',
                  lineHeight: '100%',
                  letterSpacing: 0,
                  verticalAlign: 'middle',
                  borderRadius: isMobile ? '32.31px' : '50px',
                  textTransform: 'none',
                  p: '10px 22px',
                  mb: isTablet ? 3 : 0,

                  '&:hover': {
                    transition: 'transform 0.3s ease',
                    boxShadow: 'none',
                    transform: 'scale(1.05)',
                  },
                }}
              >
                authencity.io
              </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default StayTuned;
